import React, { useState, useEffect, useContext, createContext } from "react";
import { useRouter } from "next/router";
import axios from "@/services/axios";
import { LARAVEL_URL } from "../constants";
import { postData } from "./api";
import { useMount } from "react-use";
import { isClient } from "../styles/utils";
import { getStoredAuthentication, storeAuthentication } from "@/utils/storage";

const AuthContext = createContext();

export function ProvideAuth({ children }) {
  const auth = useProvideAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  return useContext(AuthContext);
};

const useProvideAuth = () => {
  const [authenticated, setAuthenticated] = useState(null);
  const router = useRouter();

  useMount(() => {
    if (isClient()) {
      setAuthenticated(getStoredAuthentication());
    }
  });

  useEffect(() => {
    storeAuthentication(authenticated);
  }, [authenticated]);

  const login = async (formData) => {
    try {
      const token = await getCSRFCookie();

      return postData("/login", formData, {
        headers: {
          "X-XSRF-TOKEN": token,
        },
        withCredentials: true,
      }).then((res) => {
        if (res.message == "Login successful") {
          setAuthenticated(true);
        }
        return res;
      });
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  };

  return {
    authenticated,
    login,
  };
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const getCSRFCookie = async () => {
  await axios.get(`${LARAVEL_URL}/sanctum/csrf-cookie`, {
    withCredentials: true,
  });

  const token = getCookie("XSRF-TOKEN");
  return token ? decodeURIComponent(token) : null;
};
